import { Stack } from "@mui/material";

export const NoRowsOverlay = ({ message }: { message: string }) => (
  <Stack data-testid="no-rows-overlay" height="100%" alignItems="center" justifyContent="center">
    {message ?? "No Records found."}
  </Stack>
);